import script from './EmailInput.vue2.js';
import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "b-field",
    {
      attrs: {
        type: _vm.isValid ? "is-success" : _vm.value ? "is-danger" : "",
        message: _vm.value ? _vm.message : ""
      }
    },
    [
      _c("TextInput", {
        attrs: {
          "data-testid": "email",
          autocomplete: _vm.autocomplete,
          disabled: _vm.disabled,
          icon: !_vm.hideIcon ? "envelope" : null,
          label: _vm.label,
          loading: _vm.isLoading,
          placeholder: _vm.placeholder,
          value: _vm.value,
          debounce: "",
          iconPack: "fasr",
          type: "email"
        },
        on: {
          input: function(value) {
            return _vm.$emit("input", value)
          }
        },
        nativeOn: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter")
          }
        }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
